export enum SIGN_IN {
    ADMIN_USER_DIRECTORY_PASSWORD = 'LOGIN_PASSWORD',
    CHECK_YOUR_EMAILS = 'CHECK_YOUR_EMAILS',
    CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
    EMAIL_ADDRESS_OR_USERNAME = 'SIGN_IN.EMAIL_ADDRESS_OR_USERNAME',
    ENTER_CREDENTIALS = 'ENTER_CREDENTIALS',
    ENTER_EMAIL_TO_RESET_PASSWORD = 'ENTER_EMAIL_TO_RESET_PASSWORD',
    FORGOT_YOUR_PASSWORD = 'FORGOT_YOUR_PASSWORD',
    GENERIC_ERROR = 'LOGIN.GENERIC_ERROR',
    GENERIC_ERROR_LOGIN = 'LOGIN.GENERIC_ERROR_LOGIN',
    INVALID_CAPTCHA = 'LOGIN.INVALID_CAPTCHA',
    INVALID_EMAIL_ADDRESS_OR_USERNAME = 'SIGN_IN.INVALID_EMAIL_ADDRESS_OR_USERNAME',
    INVALID_EMAIL_ERROR = 'ERROR_INVALID_EMAIL_ADDRESS',
    INVALID_LOGIN = 'LOGIN.INVALID_LOGIN',
    INVALID_LOGIN_SESSION_EXPIRED = 'LOGIN.INVALID_LOGIN_SESSION_EXPIRED',
    INVALID_SAML_CONFIGURATION = 'LOGIN.INVALID_SAML_CONFIGURATION',
    NEED_LOGIN = 'LOGIN.NEED_LOGIN',
    NEW_PASSWORD = 'NEW_PASSWORD',
    NOT_AUTHORIZED_LOGIN = 'LOGIN.NOT_AUTHORIZED_LOGIN',
    NOT_ENOUGH_CHARACTERS = 'NOT_ENOUGH_CHARACTERS',
    PASSWORD_API_UPDATE_ERROR = 'LOGIN.PASSWORD_API_UPDATE_ERROR',
    PASSWORD_NOT_ENOUGH_CHARACTERS = 'PASSWORD_NOT_ENOUGH_CHARACTERS',
    PASSWORD_RESET_DO_NOT_MATCH = 'PASSWORD_RESET_DO_NOT_MATCH',
    RESET_YOUR_PASSWORD = 'RESET_YOUR_PASSWORD',
    SHOW_LESS_LOGIN_OPTIONS = 'LOGIN.SHOW_LESS_LOGIN_OPTION',
    SHOW_MORE_LOGIN_OPTIONS = 'LOGIN.SHOW_MORE_LOGIN_OPTION',
    SIGN_IN_WITH_LUMAPPS = 'SIGN_IN_WITH_LUMAPPS',
    TOO_MANY_ATTEMPTS = 'LOGIN.TOO_MANY_ATTEMPTS',
    USER_CREATION_FAILED = 'LOGIN.ERROR_USER_CREATION_FAILED',
    WELCOME = 'FRONT.TOP_USER_BENEFITS.WELCOME_TITLE',
    WELCOME_LOGIN_OPTIONS_SUBTITLE = 'WELCOME_LOGIN_OPTIONS_SUBTITLE',
}
export enum LOGOUT {
    GOOGLE = 'LOGIN_LOGOUT_GOOGLE',
    MICROSOFT = 'LOGIN_LOGOUT_MICROSOFT',
    OKTA = 'LOGIN_LOGOUT_OKTA',
}
